'use client'

import dynamic from 'next/dynamic'
import { Suspense } from 'react'

import { ChainLoader } from '../../../../../../components/chain-loader'

const WorkspacePublicPostsPage = dynamic(
  () => import('./workspace-public-posts-page').then((mod) => mod.WorkspacePublicPostsPage),
  {
    ssr: false
  }
)

interface IWorkspacePublicPostsPageClientProps {
  workspace: string
}

export function WorkspacePublicPostsPageClient({ workspace }: IWorkspacePublicPostsPageClientProps) {
  return (
    <Suspense fallback={<ChainLoader />}>
      <WorkspacePublicPostsPage workspace={workspace} />
    </Suspense>
  )
}
